import type { JourneyAnswerExportRecord } from '../types/answer-export'

import { api } from '@/shared/services/api'

type JourneyAnswerExportResponse = {
  record: JourneyAnswerExportRecord
}

export async function fetchJourneyAnswersExport(journeyUid: string) {
  const { data } = await api.get<JourneyAnswerExportResponse>(
    `/user/journeys/${journeyUid}/answers_export`
  )

  return data.record
}

export async function fetchLevelAnswersExport(
  journeyUid: string,
  levelUid: string
) {
  const { data } = await api.get<JourneyAnswerExportResponse>(
    `/user/journeys/${journeyUid}/levels/${levelUid}/answers_export`
  )

  return data.record
}
